import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  PairingRule_LongestTime_instance = new (PairingRule())('LongestTime', 0);
  PairingRule_PreferDifferentBadge_instance = new (PairingRule())('PreferDifferentBadge', 1);
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var PairingRule_LongestTime_instance;
var PairingRule_PreferDifferentBadge_instance;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      fromValue_ysai90_k$(value) {
        switch (value) {
          case 1:
            return PairingRule_LongestTime_getInstance();
          case 2:
            return PairingRule_PreferDifferentBadge_getInstance();
          default:
            return PairingRule_LongestTime_getInstance();
        }
      }
      toValue_o5h68i_k$(rule) {
        var tmp;
        switch (rule.ordinal_1) {
          case 0:
            tmp = 1;
            break;
          case 1:
            tmp = 2;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var PairingRuleClass;
function PairingRule() {
  if (PairingRuleClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'PairingRule');
    PairingRuleClass = $;
  }
  return PairingRuleClass;
}
function PairingRule_LongestTime_getInstance() {
  static_init();
  return PairingRule_LongestTime_instance;
}
function PairingRule_PreferDifferentBadge_getInstance() {
  static_init();
  return PairingRule_PreferDifferentBadge_instance;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  PairingRule_LongestTime_getInstance as PairingRule_LongestTime_getInstance62hphvxq1b3h,
  PairingRule_PreferDifferentBadge_getInstance as PairingRule_PreferDifferentBadge_getInstance37szs5dfk4t44,
  Companion_instance_0 as Companion_instanceuedomgwof6ax,
};
//endregion

//# sourceMappingURL=PairingRule.mjs.map
